import standardAPI from '@/api/standard_items';

const responseUrl = '/hotels/procedures';

const state = {
  procedures: [],
  procedures_MetaData: {},
  procedures_status: '',
  procedures_page: 1,
  procedures_perPage: 10,
};

const getters = {
  get_procedures: (state) => {
    return state.procedures;
  },
  get_procedures_status: (state) => {
    return state.procedures_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_procedures ({ commit }, getOptions) {
    commit('DATA_PROCEDURES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_PROCEDURES_UPDATE_SUCCESS', response);
            commit('DATA_PROCEDURES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_PROCEDURES_READY');
            reject(response);
          } else {
            commit('DATA_PROCEDURES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_procedures_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_procedure ({ commit, dispatch }, itemData) {
    commit('DATA_PROCEDURES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_PROCEDURES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_PROCEDURES_READY');
          reject(response);
        }
      });
    });
  },
  edit_procedure ({ commit, dispatch }, itemData) {
    commit('DATA_PROCEDURES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_PROCEDURES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_PROCEDURES_READY');
          reject(response);
        }
      });
    });
  },
  remove_procedures ({ commit, dispatch }, itemData) {
    commit('DATA_PROCEDURES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_PROCEDURES_REQUEST');
          resolve();
        } else {
          commit('DATA_PROCEDURES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_procedure ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_procedure_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.procedures_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.procedures_perPage = max;
  },
  DATA_PROCEDURES_READY: (state) => {
    state.procedures_status = 'ready';
  },
  DATA_PROCEDURES_REQUEST: (state) => {
    state.procedures_status = 'loading';
  },
  DATA_PROCEDURES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.procedures_MetaData.meta = response.meta;
      state.procedures_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.procedures = response.data || [];
    }
    state.procedures_status = 'success';
  },
  DATA_PROCEDURES_ERROR: (state) => {
    state.procedures_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
